// Generated by generateKotlinApi; do not edit.
package io.github.erkko68.kolt.physics.collision

import io.github.erkko68.kolt.*
import io.github.erkko68.kolt.capi.*
import io.github.erkko68.kolt.core.*
import io.github.erkko68.kolt.core.capi.*
import io.github.erkko68.kolt.geometry.*
import io.github.erkko68.kolt.geometry.capi.*
import io.github.erkko68.kolt.interop.*
import io.github.erkko68.kolt.math.*
import io.github.erkko68.kolt.objectstream.*
import io.github.erkko68.kolt.physics.*
import io.github.erkko68.kolt.physics.body.*
import io.github.erkko68.kolt.physics.body.capi.*
import io.github.erkko68.kolt.physics.capi.*
import io.github.erkko68.kolt.physics.character.*
import io.github.erkko68.kolt.physics.character.capi.*
import io.github.erkko68.kolt.physics.collision.broadphase.*
import io.github.erkko68.kolt.physics.collision.broadphase.capi.*
import io.github.erkko68.kolt.physics.collision.capi.*
import io.github.erkko68.kolt.physics.collision.shape.*
import io.github.erkko68.kolt.physics.collision.shape.capi.*
import io.github.erkko68.kolt.physics.constraints.*
import io.github.erkko68.kolt.physics.constraints.capi.*
import io.github.erkko68.kolt.physics.constraints.constraintpart.*
import io.github.erkko68.kolt.physics.ragdoll.*
import io.github.erkko68.kolt.physics.ragdoll.capi.*
import io.github.erkko68.kolt.physics.softbody.*
import io.github.erkko68.kolt.physics.softbody.capi.*
import io.github.erkko68.kolt.physics.vehicle.*
import io.github.erkko68.kolt.physics.vehicle.capi.*
import io.github.erkko68.kolt.skeleton.*
import io.github.erkko68.kolt.skeleton.capi.*

/**
 * Filter class to test if two objects can collide based on their object layer. Used while finding collision pairs.
 * This implementation uses a table to determine if two layers can collide.
 *
 * C++ `JPH::ObjectLayerPairFilterTable`.
 */
class ObjectLayerPairFilterTable internal constructor(internal val objectLayerPairFilterTableHandle: NativePointer, owned: Boolean = false) : ObjectLayerPairFilter(JphObjectLayerPairFilterTable_asObjectLayerPairFilter(objectLayerPairFilterTableHandle), owned), AutoCloseable {
    constructor(numObjectLayers: Int) : this(JphObjectLayerPairFilterTable_create(numObjectLayers), owned = true)

    override fun close() =
        closeOnce { JphObjectLayerPairFilterTable_destroy(objectLayerPairFilterTableHandle) }

    /** Get the number of object layers */
    val numObjectLayers: Int
        get() = JphObjectLayerPairFilterTable_GetNumObjectLayers(objectLayerPairFilterTableHandle)

    /** Disable collision between two object layers */
    fun disableCollision(layer1: Int, layer2: Int) =
        JphObjectLayerPairFilterTable_DisableCollision(objectLayerPairFilterTableHandle, layer1, layer2)

    /** Enable collision between two object layers */
    fun enableCollision(layer1: Int, layer2: Int) =
        JphObjectLayerPairFilterTable_EnableCollision(objectLayerPairFilterTableHandle, layer1, layer2)
}
